import { useEffect, useState } from 'react';
import api from './client';

// Phase F5.2 — people macro-categories (dynamic, admin-managed).
export const getCategories = async () => {
  const res = await api.get('/categories');
  return res.data.categories || [];
};

export const adminListCategories = async () => {
  const res = await api.get('/admin/categories');
  return res.data.categories || [];
};

export const adminCreateCategory = async (name) => {
  const res = await api.post('/admin/categories', { name });
  return res.data;
};

export const adminUpdateCategory = async (id, patch) => {
  const res = await api.patch(`/admin/categories/${id}`, patch);
  invalidateCategories();
  return res.data;
};

export const adminDeleteCategory = async (id) => {
  const res = await api.delete(`/admin/categories/${id}`);
  invalidateCategories();
  return res.data;
};

// Session-cached hook (same pattern as useAppConfig) — one fetch per session.
let _cache = null;
let _pending = null;

export const invalidateCategories = () => { _cache = null; _pending = null; };

export function useCategories() {
  const [cats, setCats] = useState(_cache || []);
  useEffect(() => {
    if (_cache) return;
    if (!_pending) _pending = getCategories().then((c) => { _cache = c; return c; }).catch(() => []);
    _pending.then((c) => setCats(c || []));
  }, []);
  const nameOf = (slug) => (cats.find((c) => c.slug === slug)?.name || '');
  return { categories: cats, nameOf };
}
